import styles from './styles.module.scss';
import { TransactionsCommonMappingModalContentDetailsProps } from './props';
import { TransactionsCommonMappingModalContentDetailsHeader } from './Header';
import { useTransactionById } from '@starsoft/common/hooks/transactions/useTransactionById';
import { ErrorCard } from '@starsoft/common/components/ErrorCard';
import { TransactionsCommonMappingModalContentDetailsActions } from './Actions';
import { Slide } from '@mui/material';

/**
 * TransactionsCommonMappingModalContentDetails Component
 * This component is responsible for rendering the details section of the transaction mapping modal.
 * It handles the display of error messages and the main content of the modal.
 *
 * @param {TransactionsCommonMappingModalContentDetailsProps} props - The properties for the component.
 * @param {Function} props.onClose - Callback function to handle closing the modal.
 *
 * @returns {JSX.Element} The rendered component displaying either an error card or the modal content.
 *
 * @example
 * // Usage example:
 * <TransactionsCommonMappingModalContentDetails onClose={() => function('Modal closed')} />
 */
export function TransactionsCommonMappingModalContentDetails({
  onClose,
}: TransactionsCommonMappingModalContentDetailsProps) {
  // Hook to fetch transaction data by ID and handle errors
  const { error, refetch } = useTransactionById();

  // If there is an error, render the ErrorCard component
  if (error) {
    return (
      <div className={`${styles.container} ${styles['container--error']}`}>
        <ErrorCard error={error} refetch={refetch} />
      </div>
    );
  }

  // Render the main content of the modal with a sliding animation
  return (
    <Slide in={true} direction="left" timeout={500}>
      <div className={styles.container}>
        <TransactionsCommonMappingModalContentDetailsHeader onClose={onClose} />
        <TransactionsCommonMappingModalContentDetailsActions />
      </div>
    </Slide>
  );
}
